/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { IUser } from 'app/interfaces/user/user.interface';
// import environment from 'environments/environment';
import { LoginRequest } from '../../interfaces/api-request/login-request.interface';
import apiRequest from '../api/api.request';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
import {
	getLoginAction,
	setLoginErrorAction,
	setLoginSuccessAction,
	setLoginAction,
	setCheckPasswordErrorAction,
	setCheckPasswordAction,
	checkPasswordAction,
	CheckPasswordRequest,
} from '../actions/LoginAction';
import { setGlobalLoaderAction } from '../actions/CommonAction';
import endpoints from '../../../constants/endpoints';

function* login({ payload }: { payload: LoginRequest }): Generator {
	yield put(setGlobalLoaderAction(true));
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const config: ApiRequestConfig = {
		path: endpoints.api.LOGIN,
		method: 'POST',
		headers: {},
		query: null,
		body: payload,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;

		yield put(setLoginAction(data as IUser));
	} catch (err) {
		yield put(setLoginErrorAction(err as string));
		yield put(setGlobalLoaderAction(false));
	}
}

function* storeData({ payload }: { payload: IUser }): Generator {
	localStorage.setItem('user', JSON.stringify(payload));
	if (localStorage.getItem('user')) {
		yield put(setLoginSuccessAction('success'));
		yield put(setGlobalLoaderAction(false));
	}
}

function* checkPassword({ payload }: { payload: CheckPasswordRequest }): Generator {
	yield put(setGlobalLoaderAction(true));
	const userData = localStorage.getItem('user');
	const userToken = userData && JSON.parse(userData).token;

	const config: ApiRequestConfig = {
		path: endpoints.api.CHECK_PASSWORD,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${userToken}`,
			'X-REQUEST-ID': uuidv4(),
			platform: "Web",
		},
		query: null,
		body: payload,
		timeout: 0,
	};

	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		if (data?.is_validated) {
			yield put(setCheckPasswordAction(data?.is_validated));
			yield put(setCheckPasswordErrorAction(""));
		} else {
			yield put(setCheckPasswordErrorAction("Kata sandi salah"));
		}
		yield put(setGlobalLoaderAction(false));
	} catch (err) {
		yield put(setGlobalLoaderAction(false));
		yield put(setCheckPasswordErrorAction("An error occurred"));
	}
}

export default function* loginSaga(): Generator {
	yield takeLatest(getLoginAction, login);
	yield takeEvery(setLoginAction, storeData);
	yield takeLatest(checkPasswordAction, checkPassword);
}
